import { createSlice } from '@reduxjs/toolkit'
import i18n from 'i18next'

import { ContactFormValues } from 'appTypes/contact'
import apiClient from 'helpers/clients/apiClient'
import { AppThunk } from 'store'

import { displaySnackbar } from '../snackbar/snackbarSlice'

interface InitialState {
  isLoading: boolean
  isError: boolean
  isSuccess: boolean
}

const initialState: InitialState = {
  isLoading: false,
  isError: false,
  isSuccess: false,
}

export const contactSlice = createSlice({
  name: 'contact',
  initialState,
  reducers: {
    sendContactFormStart: (state) => {
      state.isLoading = true
      state.isError = false
      state.isSuccess = false
    },
    sendContactFormSuccess: (state) => {
      state.isLoading = false
      state.isError = false
      state.isSuccess = true
    },
    sendContactFormFailure: (state) => {
      state.isError = true
      state.isLoading = false
      state.isSuccess = false
    },
    resetSuccessState: (state) => {
      state.isSuccess = false
    },
  },
})

export const { sendContactFormStart, sendContactFormSuccess, sendContactFormFailure, resetSuccessState } =
  contactSlice.actions

export default contactSlice.reducer

export const sendContactForm =
  (formData: ContactFormValues): AppThunk =>
  async (dispatch) => {
    dispatch(sendContactFormStart())

    const response = await apiClient.sendContactForm(formData)

    if (!response.success || !response.data) {
      dispatch(sendContactFormFailure())
      dispatch(displaySnackbar({ message: i18n.t('error'), isError: true }))
      return
    }
    dispatch(sendContactFormSuccess())
  }
